var _symbol, _symbol2, _symbol3, _symbol4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpritemedalsHi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "gold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.252 16.94C11.3347 16.94 10.5187 16.7267 9.804 16.3C9.08933 15.8627 8.52933 15.2387 8.124 14.428C7.71867 13.6173 7.516 12.6413 7.516 11.5C7.516 10.3693 7.724 9.39866 8.14 8.588C8.556 7.77733 9.12667 7.15333 9.852 6.716C10.5773 6.27866 11.404 6.06 12.332 6.06C13.0573 6.06 13.6653 6.19866 14.156 6.476C14.6573 6.74266 15.0573 7.036 15.356 7.356L14.62 8.22C14.3533 7.94266 14.044 7.708 13.692 7.516C13.34 7.324 12.8973 7.228 12.364 7.228C11.66 7.228 11.0467 7.404 10.524 7.756C10.0013 8.09733 9.596 8.58266 9.308 9.212C9.03067 9.84133 8.892 10.5933 8.892 11.468C8.892 12.7907 9.19067 13.8413 9.788 14.62C10.396 15.388 11.26 15.772 12.38 15.772C12.7533 15.772 13.1107 15.7187 13.452 15.612C13.7933 15.4947 14.0653 15.34 14.268 15.148V12.412H12.044V11.308H15.484V15.724C15.1533 16.076 14.7053 16.3693 14.14 16.604C13.5853 16.828 12.956 16.94 12.252 16.94Z",
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "silver",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.056 16.94C11.32 16.94 10.6373 16.8013 10.008 16.524C9.37867 16.236 8.83467 15.8573 8.37601 15.388L9.17601 14.46C9.54934 14.8547 9.98667 15.1747 10.488 15.42C11 15.6547 11.528 15.772 12.072 15.772C12.7653 15.772 13.304 15.6173 13.688 15.308C14.072 14.988 14.264 14.572 14.264 14.06C14.264 13.6973 14.184 13.4093 14.024 13.196C13.8747 12.9827 13.6667 12.8013 13.4 12.652C13.144 12.5027 12.8507 12.3533 12.52 12.204L11.016 11.548C10.6853 11.4093 10.3547 11.228 10.024 11.004C9.70401 10.78 9.43201 10.492 9.20801 10.14C8.99467 9.788 8.88801 9.356 8.88801 8.844C8.88801 8.31066 9.02667 7.836 9.30401 7.42C9.59201 6.99333 9.98667 6.66266 10.488 6.428C10.9893 6.18266 11.5547 6.06 12.184 6.06C12.8133 6.06 13.3947 6.18266 13.928 6.428C14.4613 6.66266 14.9147 6.972 15.288 7.356L14.568 8.22C14.248 7.91066 13.8907 7.67066 13.496 7.5C13.112 7.31866 12.6747 7.228 12.184 7.228C11.5973 7.228 11.1227 7.36666 10.76 7.644C10.408 7.92133 10.232 8.29466 10.232 8.764C10.232 9.09466 10.3173 9.372 10.488 9.596C10.6693 9.80933 10.8933 9.98533 11.16 10.124C11.4267 10.2627 11.6987 10.3907 11.976 10.508L13.464 11.148C13.8693 11.3187 14.232 11.5267 14.552 11.772C14.8827 12.0067 15.144 12.3 15.336 12.652C15.528 12.9933 15.624 13.4253 15.624 13.948C15.624 14.5027 15.48 15.0093 15.192 15.468C14.904 15.916 14.4933 16.2733 13.96 16.54C13.4267 16.8067 12.792 16.94 12.056 16.94Z",
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "bronze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCB386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.336 16.748V6.252H11.456C12.1707 6.252 12.7947 6.33733 13.328 6.508C13.872 6.67867 14.2933 6.95067 14.592 7.324C14.9013 7.69733 15.056 8.19333 15.056 8.812C15.056 9.33467 14.9227 9.80933 14.656 10.236C14.4 10.652 14.0213 10.94 13.52 11.1V11.164C14.1493 11.2813 14.6613 11.548 15.056 11.964C15.4613 12.38 15.664 12.9507 15.664 13.676C15.664 14.3587 15.4933 14.9293 15.152 15.388C14.8213 15.8467 14.3573 16.188 13.76 16.412C13.1627 16.636 12.4693 16.748 11.68 16.748H8.336ZM9.664 10.716H11.216C12.112 10.716 12.7573 10.5613 13.152 10.252C13.5467 9.94267 13.744 9.52133 13.744 8.988C13.744 8.38 13.536 7.948 13.12 7.692C12.7147 7.436 12.1013 7.308 11.28 7.308H9.664V10.716ZM9.664 15.692H11.488C12.3947 15.692 13.0987 15.5267 13.6 15.196C14.1013 14.8547 14.352 14.332 14.352 13.628C14.352 12.9773 14.1013 12.5027 13.6 12.204C13.1093 11.8947 12.4053 11.74 11.488 11.74H9.664V15.692Z",
    fill: "black"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "total",
    viewBox: "0 0 27 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6,
    r: 6,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18,
    r: 6,
    fill: "#DCB386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritemedalsHi);
export default __webpack_public_path__ + "static/media/Spritemedals_hi.1ffcfa5d0f3c4f28cbe1d73e7d90e7dc.svg";
export { ForwardRef as ReactComponent };